/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicModelSwitching extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicModelSwitching");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicModelSwitching.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicModelSwitching>): BackgroundJobPayloadForPeriodicModelSwitching {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicModelSwitching(), model);
        BackgroundJobPayloadForPeriodicModelSwitching.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicModelSwitching>): BackgroundJobPayloadForPeriodicModelSwitching {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicModelSwitching.newInstance(<BackgroundJobPayloadForPeriodicModelSwitching> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicModelSwitching) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicModelSwitching.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicModelSwitching): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicModelSwitching.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
